import { useState } from "react";
import { TextParagraphs } from "./TextParagraphs";
import { textContent, breackpoints } from "../services/constants";
import { Icon } from "@iconify/react/dist/iconify.js";

export const About = () => {
  const [expanded, setExpanded] = useState(false);
  const togleExpand = () => setExpanded((state) => !state);

  const vw = window.innerWidth;

  return (
    <div id="about" className="px-4 relative md:mb-2">
      <h3 className="font-h text-customBrown italic font-bold mb-4 text-3xl md:text-5xl md:py-6 md:text-center [text-shadow:_0.5px_0.5px_1px_#84735e,_-0.5px_-0.5px_0.5px_#f4eee3]">
        Про мене
      </h3>
      <div
        className={`  md:max-h-fit  w-full md:flex md:flex-row-reverse `}
        onClick={vw < breackpoints.md ? togleExpand : () => {}}
      >
        <img
          src="../images/34.webp"
          alt="Olha in Italy"
          width={200}
          className="rounded-2xl mx-auto md:w-2/5 md:h-full mb-1 animate-slow-appear"
          loading="lazy"
        />
        <TextParagraphs
          text={textContent.about}
          expanded={expanded}
          showStrings={2}
          left
        />
      </div>
      {vw < breackpoints.md && (
        <p className="flex justify-center w-full" onClick={togleExpand}>
          {expanded ? (
            <Icon
              icon="mi:chevron-double-up"
              className="animate-slow-bounce text-xl"
            />
          ) : (
            <Icon
              icon="mi:chevron-double-down"
              className="animate-slow-bounce text-xl"
            />
          )}
        </p>
      )}
    </div>
  );
};
